import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function ParallaxImage({ src, alt, className = "", strength = 60, duotone = false }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-strength, strength]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className={`absolute inset-0 h-[125%] w-full object-cover -top-[12%] ${
          duotone ? "grayscale contrast-125" : ""
        }`}
        loading="lazy"
      />
      {duotone && (
        <div
          className="absolute inset-0 mix-blend-color"
          style={{ background: "linear-gradient(160deg,#0066FF33,#FF007F33)" }}
        />
      )}
    </div>
  );
}
